import { render, staticRenderFns } from "./DatasetPermissionsView.vue?vue&type=template&id=5d3514ec&scoped=true"
import script from "./DatasetPermissionsView.vue?vue&type=script&lang=js"
export * from "./DatasetPermissionsView.vue?vue&type=script&lang=js"
import style0 from "./DatasetPermissionsView.vue?vue&type=style&index=0&id=5d3514ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3514ec",
  null
  
)

export default component.exports